export const homeData = {
  title: 'Participe das Nossas Rifas!',
  sub_title:
    'Concorra a prêmios incríveis com apenas alguns cliques. É fácil, rápido e seguro!',
  bannerImage: '/banner.png',
  howItWorks: [
    {
      title: 'Escolha sua Rifa',
      description: 'Navegue pelas opções e selecione sua rifa favorita.',
    },
    {
      title: 'Compre seu Bilhete',
      description: 'Finalize a compra de forma rápida e segura.',
    },
    {
      title: 'Aguarde o Sorteio',
      description: 'O sorteio será realizado na data informada.',
    },
  ],
}

export const fakeRifas = [
  {
    id: 1,
    title: 'Carro dos Sonhos',
    image:
      'https://s2-autoesporte.glbimg.com/E1sf1iS9BMTiP02MCuaFHCbl10c=/0x0:1980x1321/888x0/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_cf9d035bf26b4646b105bd958f32089d/internal_photos/bs/2020/d/j/qQoWftR5KFEIpuXZBBTA/376505-932276-mclaren-gtr-000.jpg',
    price: 'R$ 10,00',
  },
  {
    id: 2,
    title: 'Moto Velocidade',
    image:
      'https://imagens.ebc.com.br/b3y7QhZmOsjGl8pcw0XhsbyJoK4=/1170x700/smart/https://agenciabrasil.ebc.com.br/sites/default/files/thumbnails/image/eric_granado_motovelocidade3.jpg?itok=G_1BkF72',
    price: 'R$ 15,00',
  },
  {
    id: 3,
    title: 'Viagem Inesquecível',
    image:
      'https://forbes.com.br/wp-content/uploads/2024/03/Life_tendencias-de-viagem-2024.jpg',
    price: 'R$ 20,00',
  },
]

export const testimonials = [
  {
    id: 1,
    name: 'Claudiane Moura',
    username: '@lojaperigosa',
    text: 'Hoje iniciei minha primeira campanha no site... Amando. Os valores caem na conta automaticamente.',
    platform: 'instagram',
  },
  {
    id: 2,
    name: 'Angelica Silva',
    username: '@djAngelrj',
    text: 'Fiz e funcionou.. o Pix vai direitinho na conta, eles descontam primeiro a taxa e a sequência cai na sua conta',
    platform: 'youtube',
  },
  {
    id: 3,
    name: 'Dayse Correia',
    username: '@daysecorreia4595',
    text: 'Já fiz e é muito seguro, o dinheiro cai direto na conta',
    platform: 'youtube',
  },
  {
    id: 4,
    name: 'Samuel',
    username: '@xsonstars1521',
    text: 'Muito bem a melhor que já vi 🎉🎉🎉',
    platform: 'youtube',
  },
  {
    id: 5,
    name: 'Isabella',
    username: '@Luabellaa',
    text: 'Sim, deu super certo, consegui um ótimo lucro, essa plataforma é muito confiável, tirou todas minhas dúvidas, me passou muita segurança!',
    platform: 'youtube',
  },
  {
    id: 6,
    name: 'Guilherme Silva',
    username: '@GuilhermeSilva-wi3to',
    text: 'Parabéns aos desenvolvedores do site, muito Bom...',
    platform: 'youtube',
  },
]
export const faqs = [
  {
    question: '💳 Quais formas de pagamento são aceitas?',
    answer:
      '💬 Aceitamos pagamentos via Pix, com confirmação automática e rápida.',
    type: 'pagamento',
  },
  {
    question: '💳 Meu pagamento não foi confirmado. E agora?',
    answer:
      '💬 Seu pagamento é reconhecido automaticamente pelo processamento do Pix.\nApós a aprovação, você poderá consultar seus títulos acessando “Campanhas que estou participando”.\nSe mesmo assim não aparecer, entre em contato pelo Fale Conosco aqui no site.',
    type: 'pagamento',
  },
  {
    question: '💳 Posso pagar depois de reservar os números?',
    answer:
      '💬 Cada rifa tem seu próprio tempo limite para pagamento, configurado pelo organizador.\nFique atento, pois se o prazo expirar, os números escolhidos serão liberados para outros participantes.',
    type: 'pagamento',
  },
  {
    question: '🎟️ Como faço para participar de uma rifa?',
    answer:
      '💬 Para participar, basta acessar o menu “Campanhas” e escolher, entre as rifas ativas, aquela que mais te interessar.',
    type: 'participacao',
  },
  {
    question: '🎟️ Quantos números posso comprar por rifa?',
    answer:
      '💬 Isso depende da configuração de cada rifa. Algumas têm limite de compra por pessoa, outras não.',
    type: 'participacao',
  },
  {
    question: '🎟️ Posso escolher meus números?',
    answer:
      '💬 Temos dois tipos de rifas:\n\n- Rifas com escolha manual, onde você seleciona os números que quiser\n- Rifas aleatórias, onde o sistema sorteia os números automaticamente para você',
    type: 'participacao',
  },
  {
    question: '📅 Quando acontece o sorteio?',
    answer:
      '💬 Cada rifa possui uma data prevista para o sorteio.\nNo entanto, o sorteio só será realizado após todos os números serem vendidos, garantindo a premiação completa.',
    type: 'sorteio',
  },
  {
    question: '📅 Como é feito o sorteio?',
    answer:
      '💬 O sorteio é realizado automaticamente pela plataforma, assim que o organizador clica em “Sortear ganhador”.\nO processo é 100% automatizado, sem qualquer interferência humana, o que torna o sistema extremamente seguro e confiável.',
    type: 'sorteio',
  },
  {
    question: '📅 Onde posso acompanhar o sorteio?',
    answer:
      '💬 Você pode acompanhar o resultado:\n\n- Pelos grupos de WhatsApp do organizador\n- Na comunidade oficial da plataforma\n- Na página de checkout da rifa, onde o resultado ficará disponível após o sorteio',
    type: 'sorteio',
  },
  {
    question: '🏆 Como sei se fui o ganhador?',
    answer:
      '💬 A plataforma envia uma mensagem via WhatsApp (usando os dados do seu cadastro) informando que você foi o ganhador.\nAlém disso, o organizador da rifa pode entrar em contato diretamente com você.\n⚠️ Fique atento às regras da rifa: o ganhador precisa responder dentro do prazo. Caso contrário, o organizador poderá refazer o sorteio.',
    type: 'ganhador',
  },
  {
    question: '🏆 Como recebo meu prêmio?',
    answer:
      '💬 A forma de entrega varia conforme o tipo de prêmio.\nGeralmente, o organizador e o ganhador combinam diretamente os detalhes para envio ou retirada.',
    type: 'ganhador',
  },
  {
    question: '🏆 Preciso pagar algo para receber o prêmio?',
    answer:
      '💬 Na maioria dos casos, não!\nO prêmio é entregue sem custo para o ganhador, a menos que esteja previsto no regulamento da rifa.',
    type: 'ganhador',
  },
  {
    question: '🔒 É seguro participar das rifas?',
    answer:
      '💬 Sim! Somos uma empresa confiável, que preza pela transparência na entrega dos prêmios e pela automação dos sorteios, justamente para evitar qualquer intervenção humana e eliminar riscos de golpes.',
    type: 'seguranca',
  },
  {
    question: '🔒 Como sei que o sorteio é verdadeiro?',
    answer:
      '💬 Acesse a aba “Campanhas encerradas” para conferir os resultados e comprovações de prêmios entregues aos ganhadores.\nTudo fica registrado de forma pública e visível.',
    type: 'seguranca',
  },
  {
    question: '🔒 Meus dados estão protegidos?',
    answer:
      '💬 Sim! Seguimos todas as normas e diretrizes da LGPD (Lei Geral de Proteção de Dados) para garantir que suas informações estejam sempre seguras.',
    type: 'seguranca',
  },
  {
    question: '🧾 Recebo algum comprovante da minha compra?',
    answer:
      '💬 Sim! Você recebe a confirmação de pagamento diretamente na tela, e também um comprovante por SMS, WhatsApp ou e-mail, com todos os seus títulos comprados.',
    type: 'comprovantes-suporte',
  },
  {
    question: '🧾 Não recebi e-mail de confirmação. O que faço?',
    answer:
      '💬 Entre em contato com a gente pelo menu “Fale Conosco” para que nossa equipe possa verificar o que aconteceu.',
    type: 'comprovantes-suporte',
  },
  {
    question: '🧾 Como posso consultar meus números?',
    answer:
      '💬 Acesse o menu “Campanhas que estou participando”.\nAo clicar na campanha desejada, você verá os títulos que comprou.',
    type: 'comprovantes-suporte',
  },
  {
    question: '🧾 Como entro em contato com o suporte?',
    answer: '💬 É simples! Basta acessar o menu e clicar em “Fale Conosco”.',
    type: 'comprovantes-suporte',
  },
]
export const homeStats = [
  {
    title: 'Clientes utilizando',
    value: '+20.000 mil',
    description: 'Com campanhas ativas ou já finalizadas',
  },
  {
    title: 'Pedidos feitos',
    value: '+7 milhões',
    description: 'Através da plataforma',
  },
  {
    title: 'Atendimentos',
    value: '+2.000 mil',
    description: 'Todos os meses',
  },
]
